import { useMemo } from 'react';

import { useQueryParam } from './useQueryParam';

const qreIdRegex = /^[0-9]{1,}_[0-9]{1,}_[A-Z]{1,}$/;

const useQreId = () => {
  const qreId = useQueryParam('qreId').value ?? '';

  const isValid = useMemo(() => qreIdRegex.test(qreId), [qreId]);

  return {
    qreId: isValid ? qreId : '',
    qreIdRawValue: qreId,
    isValid: qreIdRegex.test(qreId),
  };
};

export default useQreId;
